import { useMemo } from 'react';
import { get, isEmpty } from 'lodash';
import { buildReportingLink } from '../../../breadcrumb/UseBreadcrumb';

const ipAddressField = 'ipAddress';

export default function useInfrastructureBreadcrumb(
    showBreadcrumb,
    breadCrumbsArray,
    recordId,
    breadcrumbData = {},
    dataProp,
    newBreadCrumbText,
    options = {},
    textSuffix = null
) {
    return useMemo(() => {
        if (!showBreadcrumb) {
            return [];
        }
        // When no recordId is present, we're creating a new record, so add the newBreadCrumText as the last crumb instead of adding
        // an entity name.
        if (!recordId) {
            return [...breadCrumbsArray, { text: newBreadCrumbText }];
        }

        const reportingLink = buildReportingLink(options, recordId);

        // Build the breadcrumb text with optional suffix
        let baseText = get(breadcrumbData, dataProp, '');
        // For Infrastructure, add ipAddress if exists
        const ipAddress = get(breadcrumbData, ipAddressField, '');

        if (!isEmpty(ipAddress)) {
            baseText = `${baseText} (${ipAddress})`;
        }

        const breadcrumbText = isEmpty(textSuffix) ? baseText : baseText + textSuffix;

        // We have a recordId, so add the entity name as the last crumb.
        const newBreadCrumbs = [
            ...breadCrumbsArray,
            isEmpty(breadcrumbData) ? { text: '...' } : { text: breadcrumbText },
        ];

        return reportingLink ? [...newBreadCrumbs, { reportingLink }] : newBreadCrumbs;
    }, [showBreadcrumb, recordId, options, breadcrumbData, dataProp, textSuffix, breadCrumbsArray, newBreadCrumbText]);
}
